function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;
        
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function getShopifyRoute(path) {
    const normalizedPath = String(path || '').replace(/^\/+/, '');
    const shopifyRoot = window.Shopify?.routes?.root;

    if (shopifyRoot) {
        return shopifyRoot.replace(/\/?$/, '/') + normalizedPath;
    }

    const themeRoot = window.routes?.root || '';
    return (themeRoot ? themeRoot.replace(/\/?$/, '/') : '/') + normalizedPath;
}

function getShopifyAjaxRoute(route, fallbackPath) {
    const source = route || getShopifyRoute(fallbackPath);
    const hashIndex = source.indexOf('#');
    const hash = hashIndex > -1 ? source.slice(hashIndex) : '';
    const beforeHash = hashIndex > -1 ? source.slice(0, hashIndex) : source;
    const queryIndex = beforeHash.indexOf('?');
    const query = queryIndex > -1 ? beforeHash.slice(queryIndex) : '';
    let pathname = queryIndex > -1 ? beforeHash.slice(0, queryIndex) : beforeHash;

    if (/\.js$/.test(pathname)) {
        return `${pathname}${query}${hash}`;
    }

    pathname = pathname.replace(/\/$/, '');
    return `${pathname}.js${query}${hash}`;
}

(() => {
    const searchScopeSelector = '.header__search';
    const desktopSearchMedia = window.matchMedia('(min-width: 768px)');
    const searchFormSelector = 'form.search-modal__form, form.search';
    const searchShellSelector = '.header__search-full, .header__icon--search, .header__icon--summary, [data-search-menu], [data-search-menu-sticky-form], .search_details, .search-modal__form, form.search, .field, summary';
    const searchResultSelector = '[data-predictive-search], [data-quick-trending-products], .quickSearchResultsWrap, .quickSearchResultsBlock, .predictive-search';
    const searchCloseSelector = '.header-search-close, .header-search-popup-close, .search-modal__close-button';
    const jellyClass = 'is-search-jelly';
    const activeClass = 'is-search-active';
    const formActiveClass = 'is-search-form-active';
    const cancelClass = 'olitans-search-cancel';
    const overlayClass = 'olitans-search-overlay-open';
    const recentSearchClass = 'olitans-search-recent';
    const categorySearchClass = 'olitans-search-categories';
    const viewAllClass = 'olitans-search-view-all';
    const recentStorageKey = 'olitans_recent_searches';

    const getClosest = (target, selector) => {
        return target?.closest ? target.closest(selector) : null;
    };

    const getSearchContext = (target) => {
        const scope = getClosest(target, searchScopeSelector);
        const form = scope ? getClosest(target, searchFormSelector) || scope.querySelector(searchFormSelector) : null;
        const input = form?.querySelector('.search__input, input[type="search"]') || scope?.querySelector('.search__input, input[type="search"]');
        const visualTarget = form || scope?.querySelector('.search-modal__form') || scope;

        return { scope, form, input, visualTarget };
    };

    const playJelly = (target) => {
        if (!target) return;

        target.classList.remove(jellyClass);
        void target.offsetWidth;
        target.classList.add(jellyClass);
    };

    // Search overlay fix: keep the injected desktop cancel action single-instance.
    const isDesktopInlineSearch = (scope) => {
        return !!scope && desktopSearchMedia.matches && !scope.closest('#search-form-mobile, .halo-sidebar_search');
    };

    // Search overlay fix: prevent native full-screen desktop search classes from leaking back in.
    const clearNativeDesktopSearchState = (scope) => {
        if (!isDesktopInlineSearch(scope)) return;

        document.body.classList.remove('open_search', 'open_search_desktop', 'open_search_menu', 'sticky-search-open', 'sticky-search-menu-open');
        document.querySelectorAll('[class*="section-header-"]').forEach((section) => {
            section.classList.remove('sticky-search-menu-open', 'sticky-search-menu-custom-open');
        });
    };

    // Search panel spacing / layout fix: keep the desktop panel inside the visible theme width.
    const setSearchPanelPosition = (scope) => {
        if (!isDesktopInlineSearch(scope)) return;

        const header = scope.closest('[class*="section-header-"], .shopify-section') || document.querySelector('[class*="section-header-"], .shopify-section-header-sticky, .header-classic, .header-navigation');
        const headerBottom = header?.getBoundingClientRect ? header.getBoundingClientRect().bottom : 84;
        const headerRect = header?.getBoundingClientRect ? header.getBoundingClientRect() : null;
        const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
        const contentLeft = Math.max(0, Math.round(headerRect?.left || 0));
        const contentWidth = Math.max(320, Math.min(Math.round(headerRect?.width || viewportWidth), viewportWidth - contentLeft));
        const sideGutter = contentWidth < 820 ? 16 : 24;
        const panelWidth = Math.max(320, Math.min(900, contentWidth - (sideGutter * 2), viewportWidth - 24));
        const panelLeft = Math.max(12, Math.round(contentLeft + ((contentWidth - panelWidth) / 2)));
        const panelTop = Math.max(68, Math.min(Math.round(headerBottom + 10), window.innerHeight - 260));

        document.documentElement.style.setProperty('--olitans-search-panel-top', `${panelTop}px`);
        document.documentElement.style.setProperty('--olitans-search-panel-left', `${panelLeft}px`);
        document.documentElement.style.setProperty('--olitans-search-panel-width', `${panelWidth}px`);
    };

    // Search overlay UI fix: hydrate deferred homepage search content before forcing the panel open.
    const hydrateDeferredSearchContent = (scope) => {
        scope?.querySelectorAll('template[data-olitans-defer-search-drawer]').forEach((template) => {
            if (!template.content) return;
            template.replaceWith(template.content.cloneNode(true));
        });

        if (typeof window.olitansLoadPredictiveSearch === 'function') {
            const loadRequest = window.olitansLoadPredictiveSearch();
            if (loadRequest?.catch) loadRequest.catch(() => {});
        }
    };

    // Search overlay UI fix: keep details/input state aligned with our floating panel state.
    const syncSearchOpenState = (scope, input) => {
        const details = scope?.querySelector('.search_details');
        const summary = scope?.querySelector('summary');
        const query = input?.value.trim() || '';
        const predictiveSearch = input?.closest('predictive-search') || scope?.querySelector('predictive-search');

        if (details && !details.open) details.open = true;
        summary?.setAttribute('aria-expanded', 'true');
        input?.setAttribute('aria-expanded', 'true');

        if (!query && predictiveSearch) {
            predictiveSearch.removeAttribute('open');
            predictiveSearch.removeAttribute('loading');
        }
    };

    const buildSearchUrl = (term) => {
        const query = (term || '').trim();
        const encodedQuery = encodeURIComponent(query || '*');
        const searchUrl = window.routes?.search_url || '/search';

        return `${searchUrl}?options%5Bprefix%5D=last&type=product&q=${encodedQuery}`;
    };

    const escapeHtml = (value) => {
        const element = document.createElement('span');
        element.textContent = value || '';

        return element.innerHTML;
    };

    const getRecentSearches = () => {
        try {
            const recent = JSON.parse(window.localStorage.getItem(recentStorageKey) || '[]');

            return Array.isArray(recent) ? recent.filter(Boolean).slice(0, 6) : [];
        } catch (error) {
            return [];
        }
    };

    const saveRecentSearch = (term) => {
        const query = (term || '').trim();

        if (!query) return;

        const recent = getRecentSearches().filter((item) => item.toLowerCase() !== query.toLowerCase());
        recent.unshift(query);
        window.localStorage.setItem(recentStorageKey, JSON.stringify(recent.slice(0, 6)));
    };

    const createUtilityBlock = (className, title) => {
        const block = document.createElement('div');
        block.className = `olitans-search-utility ${className}`;
        block.innerHTML = `<h3>${title}</h3><div class="olitans-search-utility__content"></div>`;

        return block;
    };

    // Search panel spacing / layout fix: hide the recent block when it has no usable content.
    const renderRecentSearches = (container) => {
        const content = container?.querySelector('.olitans-search-utility__content');
        const recent = getRecentSearches();

        if (!content) return;

        if (!recent.length) {
            container.hidden = true;
            container.classList.add('is-empty');
            content.innerHTML = '';
            return;
        }

        container.hidden = false;
        container.classList.remove('is-empty');
        content.innerHTML = recent.map((term) => `<a href="${buildSearchUrl(term)}">${escapeHtml(term)}</a>`).join('');
    };

    // Search overlay UI fix: add lightweight grouping without changing Shopify search data.
    const ensureSearchUtilityBlocks = (scope, input) => {
        if (!isDesktopInlineSearch(scope)) return;

        const container = scope.querySelector('[data-quick-trending-products] .quickSearchResults .container');

        if (!container) return;

        let recentBlock = container.querySelector(`.${recentSearchClass}`);
        if (!recentBlock) {
            recentBlock = createUtilityBlock(recentSearchClass, 'Recent Searches');
            container.insertAdjacentElement('afterbegin', recentBlock);
        }
        renderRecentSearches(recentBlock);

        let categoryBlock = container.querySelector(`.${categorySearchClass}`);
        if (!categoryBlock) {
            categoryBlock = createUtilityBlock(categorySearchClass, 'Shop by Category');
            categoryBlock.querySelector('.olitans-search-utility__content').innerHTML = [
                ['Folding Knives', 'folding knife'],
                ['Fixed Blades', 'fixed blade'],
                ['Accessories', 'accessories'],
                ['Parts / Scales', 'knife scales']
            ].map(([label, term]) => `<a href="${buildSearchUrl(term)}">${escapeHtml(label)}</a>`).join('');

            const productBlock = container.querySelector('.quickSearchProduct');
            (productBlock || container).insertAdjacentElement(productBlock ? 'beforebegin' : 'beforeend', categoryBlock);
        }

        let viewAll = container.querySelector(`.${viewAllClass}`);
        if (!viewAll) {
            viewAll = document.createElement('a');
            viewAll.className = viewAllClass;
            viewAll.textContent = 'View all results';
            container.insertAdjacentElement('beforeend', viewAll);
        }

        viewAll.href = buildSearchUrl(input?.value || '');
    };

    const cleanupCancelButtons = (scope) => {
        const buttons = Array.from(scope?.querySelectorAll(`.${cancelClass}`) || []);

        buttons.slice(1).forEach((button) => button.remove());

        return buttons[0] || null;
    };

    const ensureCancelButton = (scope, form) => {
        if (!scope || !form) return;

        const existingButton = cleanupCancelButtons(scope);

        if (!isDesktopInlineSearch(scope)) return;

        if (existingButton) {
            if (existingButton.previousElementSibling !== form) {
                form.insertAdjacentElement('afterend', existingButton);
            }

            existingButton.setAttribute('aria-label', 'Close search');
            existingButton.textContent = '×';
            return;
        }

        const cancelButton = document.createElement('button');
        cancelButton.type = 'button';
        cancelButton.className = cancelClass;
        cancelButton.setAttribute('aria-label', 'Close search');
        cancelButton.textContent = '×';
        form.insertAdjacentElement('afterend', cancelButton);
    };

    const setSearchActive = (scope, form, isActive = true) => {
        if (!scope) return;

        scope.classList.toggle(activeClass, isActive);
        form?.classList.toggle(formActiveClass, isActive);

        if (isDesktopInlineSearch(scope)) {
            if (isActive) {
                setSearchPanelPosition(scope);
            }

            document.body.classList.toggle(overlayClass, isActive);

            if (isActive) {
                clearNativeDesktopSearchState(scope);
                window.setTimeout(() => clearNativeDesktopSearchState(scope), 0);
            }
        }

        if (isActive) {
            ensureCancelButton(scope, form);
            ensureSearchUtilityBlocks(scope, form?.querySelector('.search__input, input[type="search"]'));
        }
    };

    const showDefaultSearchPanel = (scope, input) => {
        if (!scope || input?.value.trim()) return;

        hydrateDeferredSearchContent(scope);
        syncSearchOpenState(scope, input);

        scope.querySelectorAll('.quickSearchResultsWrap[data-quick-trending-products]').forEach((panel) => {
            panel.classList.remove('hidden', 'is-hidden');
            panel.classList.add('is-show');
        });
    };

    const hideSearchPanels = (scope) => {
        scope?.querySelectorAll('.quickSearchResultsWrap').forEach((panel) => {
            panel.classList.remove('is-show');
            panel.classList.add('is-hidden');
        });
    };

    const shouldKeepSearchBoxOnly = () => false;

    const closeInlineSearchPanel = (scope) => {
        const details = scope?.querySelector('.search_details');

        if (details?.open) {
            details.open = false;
        }

        document.body.classList.remove('open_search', 'open_search_desktop');
    };

    const closeSearchScope = (scope, options = {}) => {
        const form = scope?.querySelector(searchFormSelector);
        const input = form?.querySelector('.search__input, input[type="search"]') || scope?.querySelector('.search__input, input[type="search"]');
        const details = form?.closest('.search_details') || scope?.querySelector('.search_details');

        if (options.clear && input) {
            input.value = '';
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (details?.open) {
            details.open = false;
        }

        hideSearchPanels(scope);
        cleanupCancelButtons(scope);
        setSearchActive(scope, form, false);
        document.body.classList.remove('open_search', 'open_search_desktop', 'open_search_menu', 'sticky-search-open', 'sticky-search-menu-open', overlayClass);
        document.documentElement.style.removeProperty('--olitans-search-panel-top');
        document.documentElement.style.removeProperty('--olitans-search-panel-left');
        document.documentElement.style.removeProperty('--olitans-search-panel-width');
        scope?.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-open', 'sticky-search-menu-custom-open');
    };

    const focusSearchInput = (input) => {
        if (!input) return;

        const focusInput = () => {
            try {
                input.focus({ preventScroll: true });
            } catch (error) {
                input.focus();
            }

            if (input.value) {
                try {
                    input.setSelectionRange(input.value.length, input.value.length);
                } catch (error) {}
            }
        };

        focusInput();
        window.setTimeout(focusInput, 0);
    };

    const openSearchDetails = (scope, form, input) => {
        if (shouldKeepSearchBoxOnly(scope, input)) {
            closeInlineSearchPanel(scope);
            focusSearchInput(input);
            window.setTimeout(() => closeInlineSearchPanel(scope), 0);
            return;
        }

        hydrateDeferredSearchContent(scope);
        const details = form?.closest('.search_details') || scope?.querySelector('.search_details');

        if (details && !details.open) {
            details.open = true;
        }

        const stabilizeSearchPanel = () => {
            clearNativeDesktopSearchState(scope);
            setSearchPanelPosition(scope);
            setSearchActive(scope, form, true);
            ensureSearchUtilityBlocks(scope, input);
            syncSearchOpenState(scope, input);
            showDefaultSearchPanel(scope, input);
        };

        stabilizeSearchPanel();
        focusSearchInput(input);

        window.setTimeout(stabilizeSearchPanel, 0);
        window.requestAnimationFrame(stabilizeSearchPanel);
    };

    document.addEventListener('focus', (event) => {
        if (!event.target.matches('.header__search .search__input, .header__search input[type="search"]')) return;

        const { scope, input } = getSearchContext(event.target);

        if (!shouldKeepSearchBoxOnly(scope, input)) return;

        event.stopPropagation();
        event.stopImmediatePropagation();
        window.setTimeout(() => closeInlineSearchPanel(scope), 0);
    }, true);

    document.addEventListener('click', (event) => {
        const { scope, form, input, visualTarget } = getSearchContext(event.target);

        if (!scope || !form || !input) return;

        const isCancelClick = getClosest(event.target, `.${cancelClass}`);
        const isCloseClick = getClosest(event.target, searchCloseSelector);

        if (isCancelClick || isCloseClick) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            closeSearchScope(scope, { clear: !!isCancelClick });
            return;
        }

        const isSearchResultClick = getClosest(event.target, searchResultSelector);

        if (isSearchResultClick && scope.contains(isSearchResultClick)) return;

        const isSearchShellClick = getClosest(event.target, searchShellSelector) || event.target === scope;

        if (!isSearchShellClick) return;

        const searchButton = getClosest(event.target, '.search__button');
        const hasSearchTerm = input?.value.trim().length > 0;

        playJelly(visualTarget);

        if (searchButton && hasSearchTerm) return;

        // Search overlay UI fix: own the desktop search opener before theme.js closes it again.
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openSearchDetails(scope, form, input);
    }, true);

    document.addEventListener('focusin', (event) => {
        if (!event.target.matches('.header__search .search__input, .header__search input[type="search"]')) return;

        const { scope, form, input, visualTarget } = getSearchContext(event.target);

        if (!scope || !form || !input) return;

        playJelly(visualTarget);
        setSearchActive(scope, form, true);
        openSearchDetails(scope, form, input);
    });

    document.addEventListener('input', (event) => {
        if (!event.target.matches('.header__search .search__input, .header__search input[type="search"]')) return;

        const { scope, form, input } = getSearchContext(event.target);

        if (!scope || !form || !input) return;

        setSearchActive(scope, form, true);
        ensureSearchUtilityBlocks(scope, input);
        showDefaultSearchPanel(scope, input);
    });

    document.addEventListener('submit', (event) => {
        const { scope, input } = getSearchContext(event.target);

        if (!scope || !input) return;

        saveRecentSearch(input.value);
    }, true);

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        document.querySelectorAll(`${searchScopeSelector}.${activeClass}`).forEach((scope) => {
            closeSearchScope(scope);
        });
    });

    window.addEventListener('resize', () => {
        document.querySelectorAll(`${searchScopeSelector}.${activeClass}`).forEach((scope) => {
            setSearchPanelPosition(scope);
        });
    });

    document.addEventListener('click', (event) => {
        document.querySelectorAll(`${searchScopeSelector}.${activeClass}`).forEach((scope) => {
            if (scope.contains(event.target)) return;

            closeSearchScope(scope);
        });
    });

    document.addEventListener('animationend', (event) => {
        if (!event.target.classList.contains(jellyClass)) return;

        event.target.classList.remove(jellyClass);
    });
})();

(() => {
    const productCardSelector = '.product-item, .product, .card';
    const productLinkSelector = '.card-media .card-link, .card-title a, .card-information a[href], .card-vendor a[href]';
    const interactiveSelector = 'button, input, select, textarea, label, .card-wishlist, .card-compare, .card-quickview, .card-action, [data-wishlist], [data-open-quick-view-popup], [data-product-compare]';
    const sliderTrackSelector = '.products-carousel, .products-flex, .slider, .slider--tablet, .slick-slider';
    const swipeThreshold = 8;
    let activeTouch = null;

    const getClosest = (target, selector) => {
        return target?.closest ? target.closest(selector) : null;
    };

    const getProductCard = (target) => {
        const card = getClosest(target, productCardSelector);
        return card?.closest('.product-item, .product') || card;
    };

    const clearSuppressedClick = (card) => {
        if (!card) return;
        window.clearTimeout(card._cardSwipeClickTimer);
        card._cardSwipeClickTimer = window.setTimeout(() => {
            delete card.dataset.cardSwipeClickSuppressed;
        }, 350);
    };

    document.addEventListener('touchstart', (event) => {
        const target = event.target;
        const card = getProductCard(target);
        if (!card || !card.closest(sliderTrackSelector) || !event.touches.length) return;

        const touch = event.touches[0];
        activeTouch = {
            card,
            isInteractive: !!getClosest(target, interactiveSelector),
            startX: touch.clientX,
            startY: touch.clientY,
            moved: false
        };
    }, { passive: true });

    document.addEventListener('touchmove', (event) => {
        if (!activeTouch || !event.touches.length) return;

        const touch = event.touches[0];
        const deltaX = Math.abs(touch.clientX - activeTouch.startX);
        const deltaY = Math.abs(touch.clientY - activeTouch.startY);

        if (deltaX > swipeThreshold && deltaX > deltaY) {
            activeTouch.moved = true;
            if (!activeTouch.isInteractive) {
                activeTouch.card.dataset.cardSwipeClickSuppressed = 'true';
            }
        }
    }, { passive: true });

    document.addEventListener('touchend', () => {
        if (!activeTouch) return;
        if (activeTouch.moved && !activeTouch.isInteractive) clearSuppressedClick(activeTouch.card);
        activeTouch = null;
    }, { passive: true });

    document.addEventListener('touchcancel', () => {
        if (activeTouch?.moved && !activeTouch.isInteractive) clearSuppressedClick(activeTouch.card);
        activeTouch = null;
    }, { passive: true });

    document.addEventListener('click', (event) => {
        const target = event.target;
        const card = getProductCard(target);
        if (!card || card.dataset.cardSwipeClickSuppressed !== 'true') return;
        if (getClosest(target, interactiveSelector)) return;

        const link = getClosest(target, productLinkSelector);
        if (!link) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        delete card.dataset.cardSwipeClickSuppressed;
    }, true);
})();

function getJsonRequestErrorMessage(error, fallback = null) {
    const defaultMessage = fallback || window.cartStrings?.cartError || 'Cart request failed. Please refresh the page and try again.';
    const technicalPatterns = [
        /did not match the expected pattern/i,
        /failed to execute .*queryselector/i,
        /not a valid selector/i,
        /invalid selector/i,
        /unexpected token/i,
        /not valid json/i,
        /domexception/i,
        /networkerror/i,
        /load failed/i
    ];
    const normalizeMessage = (message) => {
        if (!message || typeof message !== 'string') return defaultMessage;
        return technicalPatterns.some((pattern) => pattern.test(message)) ? defaultMessage : message;
    };

    if (error && typeof error === 'object') {
        if (error.responseJSON) return getJsonRequestErrorMessage(error.responseJSON, fallback);
        if (error.responseText) {
            try {
                return getJsonRequestErrorMessage(JSON.parse(error.responseText), fallback);
            } catch (parseError) {
                return defaultMessage;
            }
        }
        if (error.description) return normalizeMessage(error.description);
        if (error.message) return normalizeMessage(error.message);
    }

    if (typeof error === 'string' && error) return normalizeMessage(error);

    return defaultMessage;
}

function parseJsonResponse(response) {
    return response.text().then((text) => {
        let parsedResponse = null;

        try {
            parsedResponse = text ? JSON.parse(text) : {};
        } catch (error) {
            console.error('Expected JSON but received a non-JSON response.', {
                status: response.status,
                url: response.url,
                contentType: response.headers?.get('content-type'),
                responsePreview: text ? text.slice(0, 500) : ''
            });

            throw new Error(window.cartStrings?.cartError || 'Cart request failed. Please refresh the page and try again.');
        }

        if (!response.ok || parsedResponse.status >= 400 || parsedResponse.errors) {
            throw parsedResponse;
        }

        return parsedResponse;
    });
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function(callback, errorCallback, retryCount = 3) {
    const requestCart = (attempt = 0) => {
        $.ajax({
            type: 'GET',
            url: getShopifyRoute('cart.js'),
            dataType: 'json',
            cache: false,
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    Shopify.onCartUpdate(cart);
                }
            },
            error: function(xhr) {
                const shouldRetry = attempt < retryCount && (!xhr || xhr.status === 0 || xhr.status === 429 || xhr.status === 503);

                if (shouldRetry) {
                    window.setTimeout(() => requestCart(attempt + 1), 350 * (attempt + 1));
                    return;
                }

                if ((typeof errorCallback) === 'function') {
                    errorCallback(xhr);
                    return;
                }

                showWarning(getJsonRequestErrorMessage(xhr), warningTime);
            }
        });
    };

    requestCart();
}

Shopify.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function(lineItemKey, quantity, index, callback) {
    getCartUpdate(lineItemKey, index, quantity, callback)
}

Shopify.removeItem = function(lineItemKey, index, callback) {
    getCartUpdate(lineItemKey, index, 0, callback)
}

function getCartUpdate(lineItemKey, line, quantity, callback) {
    const cartLine = lineItemKey ? { id: lineItemKey } : { line };
    const body = JSON.stringify({
        ...cartLine,
        quantity,
        sections_url: window.location.pathname,
    });

    fetch(getShopifyAjaxRoute(window.routes?.cart_change_url, 'cart/change.js'), { ...fetchConfig(), ...{ body } })
    .then((response) => {
        return parseJsonResponse(response);
    })
    .then((parsedState) => {
        if (parsedState.errors) {
            showWarning('Error : ' + parsedState.errors, warningTime);
            return;
        }

        if ((typeof callback) === 'function') {
            callback(parsedState);
        } else {
            Shopify.onCartUpdate(parsedState);
        }
    })
    .catch((e) => {
        console.error(e);
        showWarning(getJsonRequestErrorMessage(e), warningTime);
    })
}

Shopify.addItem = function(variant_id, quantity, $target, callback, input = null) {
    var quantity = quantity || 1;
    let dataForm = 'quantity=' + quantity + '&id=' + variant_id;

    if ($target.closest('form')) {
        const $thisForm = $target.closest('form');
        const $properties = $thisForm.find('[name^="properties"]');
        if ($properties.length) $properties.each((index, element) => {dataForm = `${dataForm}&${$(element).attr('name')}=${$(element).val()}`})
    }

    var params = {
        type: 'POST',
        url: getShopifyAjaxRoute(window.routes?.cart_add_url, 'cart/add.js'),
        data: dataForm,
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            var message = window.cartStrings.addProductOutQuantity2;
            if (input && input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            } 
            
            Shopify.onError(XMLHttpRequest, textStatus, message);
            $target.removeClass('is-loading');
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    var data = {};

    try {
        data = JSON.parse(XMLHttpRequest.responseText);
    } catch (error) {
        console.error('Expected JSON but received a non-JSON cart error response.', {
            status: XMLHttpRequest.status,
            responsePreview: XMLHttpRequest.responseText ? XMLHttpRequest.responseText.slice(0, 500) : ''
        });
    }

    if (!!data.message) {
        const requestMessage = data.description || data.message + ': ' + message;
        showWarning(getJsonRequestErrorMessage(requestMessage), warningTime);
    } else {
        showWarning(getJsonRequestErrorMessage(data, message), warningTime);
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeCart = false;
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
    onButtonClick(event) {
        event.preventDefault();
        const $target = event.target
        let el_input = $target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = $target.closest('.product-form')?.querySelector('[data-btn-addtocart]');
        let newVal, checkAvailabel = false;

        const policyArray = document.body.matches('.quickshop-popup-show') ? window[`quick_shop_policy_array_${this.input.dataset.product}`] : window[`cart_selling_array_${this.dataset.product}`],
            currentId = document.body.matches('.quickshop-popup-show') ? this.closest('.productView-options').querySelector('[name="id"]').value : this.input.dataset.cartQuantityId,
            thisVariantStatus = policyArray[currentId];

        buttonAdd?.dataset.available == 'false' || buttonAdd?.dataset.available == undefined ? checkAvailabel = true : checkAvailabel = false;

        if ($target.matches('.plus')) newVal = value + 1;
        else if ($target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal < 0 ) newVal = 1;

        if (newVal > inStockNumber && checkAvailabel && thisVariantStatus == 'deny') {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }

        el_input.value = newVal;

        if (typeof this.changeCart  == 'number') {clearTimeout(this.changeCart)};
        this.changeCart = setTimeout(() => {if ($target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent)}, 350);
    }

    quantityCheckedToBeContinue() {
        const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
        return sellingArray == undefined ? false : sellingArray[this.querySelector('[name="quantity"]').dataset.cartQuantityId] === 'continue'
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onChangeQuantity.bind(this))
        );
        this.input.addEventListener('change', this.onChangeQuantity.bind(this))
    }
    
    onChangeQuantity(event) {
        event.preventDefault();
        const target = event.target;
        let el_input = target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = target.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');
        let newVal;

        if (target.matches('.plus')) newVal = value + 1;
        else if (target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal <= 0) newVal = 1;

        if (newVal > inStockNumber && !buttonAdd.matches('.button--pre-untrack')) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }
        
        el_input.value = newVal;
        if (target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}

class ProductScroller extends HTMLElement {
    constructor() {
        super();    
        this.container = this.querySelector('[data-drag-container]');
        this.dragParent = this.querySelector('[data-drag-parent]');

        this.initDragToScroll();

        this.container.setAttribute('style','--width: ' + this.container.clientWidth + 'px;');

        window.addEventListener('resize', () => {
            this.container.setAttribute('style','--width: ' + this.container.clientWidth + 'px;');
        });
    }

    initDragToScroll() {
        const isOverflowing = (wrapper) => {
            return wrapper.clientWidth < wrapper.scrollWidth
        }
        let containerOverflowing = isOverflowing(this.container)

        if (containerOverflowing) {
            this.dragToScroll(this.container)
            return 
        }
        this.dragToScroll(this.dragParent)
    }   
    
    dragToScroll(slider) {
        let mouseDown = false;
        let start;
        let scrollLeft;
        let inactiveTimeout;
        let isDragging = false;
        const dragThreshold = 6;

        slider.addEventListener('mousedown', (e) => {
            const target = e.target 

            mouseDown = true;
            isDragging = false;
            start = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseup', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, isDragging ? 120 : 0)
            isDragging = false;
        });

        slider.addEventListener('mousemove', (e) => {
            if(!mouseDown) return;
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - start) * 1;

            if (!isDragging && Math.abs(walk) < dragThreshold) return;

            isDragging = true;
            e.preventDefault();

            if (!slider.classList.contains('active')) {
                slider.classList.add('active');
            }
            slider.scrollLeft = scrollLeft - walk;
        });

        slider.addEventListener('mouseleave', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });
    }
}

class ImageToFlip extends HTMLElement {
    constructor() {
        super() 

        this.imageContainer = this; 
        this.initObserver();
    }   

    initObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
            const imageRef = entries[0]

            if (imageRef.isIntersecting) {
                imageRef.target.classList.add('show')
                observer.unobserve(imageRef.target)
            }

        }, 
        {
            threshold: 0.4 
        });
        
        this.observer.observe(this.imageContainer);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    customElements.define('product-scroller', ProductScroller);
    // customElements.define('image-to-flip', ImageToFlip);
})

function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initObserver();
    }

    initObserver() {
        const handler = (entries, observer) => {
            if (entries[0].isIntersecting) {
                this.classList.add('fade-in');

                observer.unobserve(this);
            }
        }

        const options = {
            threshold: 0.7
        }

        this.observer = new IntersectionObserver(handler, options); 
        this.observer.observe(this);
    }
}

window.addEventListener('load', () => {
    customElements.define('fade-in-component', FadeInComponent);
    this.loadScrolling();
})

window.onscroll = () => {this.loadScrolling()};

function loadScrolling() {
    document.querySelectorAll('[data-scrolling]').forEach(element => {element.dataset.scrolling == 'vertical' ? this.scrollVertical(element) : this.scrollHorizontal(element)})
}

function scrollVertical(element) {
    const $thisItem = element.closest('.special-banner__item') || element,
        top = $thisItem.getBoundingClientRect().top,
        height = $thisItem.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        coefficient = element.scrollHeight/height,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2;

    if (top - redundant < 0 && top > height*-1) this.scrollTop(element, (top*-1 + redundant)*coefficient)
    else if (top - redundant >= 0) this.scrollTop(element, 0)
    else this.scrollTop(element, element.scrollHeight)
}

function scrollTop(element, scope) {
    element.scrollTo({top: scope, behavior: "smooth"})
}

function scrollHorizontal(element) {
    const $thisFirst = element.querySelector('.scrolling-text__list--1'),
        $thisSecond = element.querySelector('.scrolling-text__list--2');

    if (!$thisFirst) return;
  
    const top = element.getBoundingClientRect().top,
        height = element.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        scrollWidth = $thisFirst.scrollWidth > window.innerWidth ? $thisFirst.scrollWidth - window.innerWidth : 0,
        contentHeight = $thisFirst.getBoundingClientRect().height*2,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2,
        coefficient = scrollWidth/(height/2 + redundant - contentHeight);
    
    let scope = (top*-1 + redundant)*coefficient,
        scope2 = (height/2 - contentHeight + redundant)*coefficient - scope;
    
    if (top - redundant < 0 && top - contentHeight > height*-1/2) {scope = scope*-1; scope2 = scope2*-1}
    else if (top - redundant >= 0) {scope = 0; scope2 = scrollWidth*-1}
    else {scope = scrollWidth*-1; scope2 = 0}
    $thisFirst.scrollWidth <= window.innerWidth ? $thisSecond.style.justifyContent = 'flex-end' : this.translateX($thisFirst, $thisSecond, scope, scope2);
}

function translateX($thisFirst, $thisSecond, scope, scope2) {
    $thisFirst.style.transform = `translateX(${scope}px)`;
    $thisSecond.style.transform = `translateX(${(scope2)}px)`;
}

class SmoothScrollMenu {
    constructor(selector) {
        this.menuItems = document.querySelectorAll(selector);
        this.attachEvents();
        this.hideMenuItemsWithoutSection();
    }

    attachEvents() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            if (anchor && anchor.getAttribute('href') && anchor.getAttribute('href') !== "#") {
                anchor.addEventListener('click', event => this.handleMenuItemClick(event, anchor));
            }
        });
    }

    handleMenuItemClick(event, anchor) {
        event.preventDefault();

        var targetHref = anchor.getAttribute('href');
        var shouldScroll = true;
        const location = window.location.pathname + window.location.hash;

        if (targetHref.includes('/') && location !== targetHref) {
            window.location.href = targetHref;
            shouldScroll = false;
        }

        if (shouldScroll) {
            var targetElement = document.getElementById(anchor.getAttribute('href').split('#')[1]);
            if (targetElement) {
                this.scrollToSection(targetElement);
            }
        }
    }

    scrollToSection(element) {
        this.smoothScrollTo(element);
    }

    smoothScrollTo(element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop
        });
    }

    hideMenuItemsWithoutSection() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            const hash = anchor.getAttribute('href').split('#')[1];
            if (hash !== undefined && hash !== '' && !document.getElementById(hash)) {
                item.style.display = 'none';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new SmoothScrollMenu('.header__inline-menu .menu-lv-1');
    customElements.define('details-disclosure', DetailsDisclosure);
});

class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp);
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.focus();
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open')
    }
}

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class PositiveVibesComponent extends HTMLElement {
    constructor() {
        super();
        this.productPositiveVibes();
    }

    productPositiveVibes() {
        const parent = this.querySelector('.text-vibes');
        const children = this.querySelectorAll('.text-vibes--child');
        let currentIndex = 0;

        if (children.length > 1) {
            const newDiv = document.createElement("div");
            newDiv.classList.add("text-vibes--child");
            newDiv.innerHTML = children[0].innerHTML;
            parent.appendChild(newDiv);
            
            const childrens = parent.querySelectorAll('.text-vibes--child');
            setInterval(() => {
                const height = childrens[currentIndex].offsetHeight;
                childrens.forEach((child, index) => {
                    parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
                    if (currentIndex == 0) {
                        parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
                    }
                });
                currentIndex = (currentIndex + 1) % childrens.length;
                this.heightPositive();
            }, 3000);
        }
    }

    heightPositive() {
        const parent = this.querySelector('.text-vibes');
        const childrens = this.querySelectorAll('.text-vibes--child');
        
        let maxHeight = 0;
        childrens.forEach(child => {
            maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
        });

        this.style.minHeight = maxHeight + 'px';

        childrens.forEach(child => {
            child.style.minHeight = `${maxHeight}px`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    customElements.define('positive-vibes', PositiveVibesComponent);
})

function checkTransparentHeader() {
    allowTransparent();

    if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", allowTransparent);
        document.addEventListener("shopify:section:unload", allowTransparent);
        document.addEventListener("shopify:section:reorder", allowTransparent);
    }
}

function allowTransparent() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
        return;
    } else {
        document.querySelector("body").removeAttribute("allow-transparency");
    }
}

document.addEventListener('DOMContentLoaded', function () {
    checkTransparentHeader();
});

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}

class BulkAdd extends HTMLElement {
    constructor() {
        super();
        this.queue = [];
        this.requestStarted = false;
        this.ids = [];
    }

    startQueue(id, quantity) {
        this.queue.push({ id, quantity });
        const interval = setInterval(() => {
            if (this.queue.length > 0) {
                if (!this.requestStarted) {
                    this.sendRequest(this.queue);
                }
            } else {
                clearInterval(interval);
            }
        }, 250);
    }

    sendRequest(queue) {
        this.requestStarted = true;
        const items = {};
        queue.forEach((queueItem) => {
            items[parseInt(queueItem.id)] = queueItem.quantity;
        });
        this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
        const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
        quickBulkElement.updateMultipleQty(items);
    }

    resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
    }

    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
    }

    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;

        if (inputValue < event.target.dataset.min) {
            this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
        } else if (inputValue > parseInt(event.target.max)) {
            this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
        } else if (inputValue % parseInt(event.target.step) != 0) {
            this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
        } else {
            event.target.setCustomValidity('');
            event.target.reportValidity();
            this.startQueue(index, inputValue);
        }
    }

    getSectionsUrl() {
        if (window.pageNumber) {
            return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
            return `${window.location.pathname}`;
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
}

if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd);
}

class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
  
      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.addEventListener('input', debounce((event) => {
          this.onChange(event);
        }, 300).bind(this))
      }
    }
  
    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a')
    }
  
    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      // Don't reset if the user has selected an element on the predictive search dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
      }
    }
  }
  customElements.define('search-form', SearchForm);

// Mobile menu accordion fix: keep submenu expansion in the current drawer level.
(() => {
    const mobileQuery = window.matchMedia('(max-width: 1024px)');
    const navSelector = '#navigation-mobile [data-navigation-mobile]';
    const triggerSelector = `${navSelector} .menu_mobile_link, ${navSelector} .menu_mobile_link_2`;
    const submenuSelector = [
        ':scope > .menu-dropdown',
        ':scope > .menu-lv__dropdownmenu',
        ':scope > .list-menu--disclosure-1',
        ':scope > .list-menu--disclosure-2',
        ':scope > .site-nav-list > .site-nav-sub',
        ':scope > .site-nav-list > .menu-lv__dropdownmenu-2',
        ':scope > .site-nav-sub'
    ].join(',');

    document.addEventListener('click', (event) => {
        if (!mobileQuery.matches) return;

        const trigger = event.target.closest(triggerSelector);
        if (!trigger) return;

        const menuItem = trigger.closest('.menu-lv-item, .site-nav');
        const submenu = menuItem?.querySelector(submenuSelector);
        if (!menuItem || !submenu) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const nav = trigger.closest('[data-navigation-mobile]');
        const shouldOpen = !menuItem.classList.contains('is-accordion-open');

        nav?.classList.add('olitans-mobile-accordion');

        [...(menuItem.parentElement?.children || [])].forEach((sibling) => {
            if (sibling !== menuItem) {
                sibling.classList.remove('is-accordion-open');
                sibling.querySelector(':scope > a, :scope > .site-nav-list > a')?.setAttribute('aria-expanded', 'false');
            }
        });

        menuItem.classList.toggle('is-accordion-open', shouldOpen);
        trigger.setAttribute('aria-expanded', String(shouldOpen));
    }, true);
})();
